import { DialogActions, Typography } from '@mui/material';
import React from 'react';

import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import CreditRequestStatus from '../../../../../../../common/CreditRequestStatus';

const ShoppingCartAccepted = (props: any) => {
  const {
    setOpenShoppingCart,
    openRequest,
    handleOpenDeleteConfirmModal,
    handleOpenUpdateStatusModal,
    canEditRequest,
  } = props;

  return (
    <div>
      <div>
        <CreditRequestStatus
          openRequest={openRequest}
          audienceType="received"
        />
        <DialogActions>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '10px 0px',
              gap: '10px',
            }}
          >
            <div
              style={{
                marginTop: 10,
                paddingBottom: 10,
                display: 'flex',
                gap: 10,
              }}
            >
              <Typography
                color="error"
                variant="body1"
                fontWeight="bold"
                style={{ cursor: 'pointer' }}
                onClick={() => handleOpenDeleteConfirmModal()}
              >
                Eliminar
              </Typography>
              {canEditRequest() && (
                <Typography
                  color="orange"
                  variant="body1"
                  fontWeight="bold"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleOpenUpdateStatusModal()}
                >
                  Editar Estado
                </Typography>
              )}
            </div>
            <div
              style={{
                marginTop: 10,
                paddingBottom: 10,
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 10,
              }}
            >
              <CustomButton
                color="secondary"
                onClick={() => {
                  setOpenShoppingCart(false);
                }}
              >
                Salir
              </CustomButton>
            </div>
          </div>
        </DialogActions>
      </div>
    </div>
  );
};

export default ShoppingCartAccepted;
